import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function WhyChooseUs() {
  const bullets = ['Atención profesional y directa', 'Explicación clara antes de avanzar', 'Tratamientos enfocados en resolver', 'Comunicación rápida por WhatsApp', 'Orientación sin rodeos innecesarios', 'Ideal para pacientes que buscan claridad'];
  return <section className="bg-white py-20 lg:py-28" data-id="element-189">
      <div className="container mx-auto px-4 md:px-6" data-id="element-190">
        <div className="grid gap-12 lg:grid-cols-2 items-center" data-id="element-191">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="order-2 lg:order-1" data-id="element-192">
            <img src="https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=2070&auto=format&fit=crop" alt="Atención dental profesional" className="rounded-2xl object-cover shadow-xl h-[400px] w-full lg:h-[500px]" data-id="element-193" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="order-1 lg:order-2" data-id="element-194">
            <h2 className="mb-8 text-3xl font-bold tracking-tight text-brand-dark sm:text-4xl" data-id="element-195">
              Una consulta dental pensada para ir al punto
            </h2>

            <ul className="space-y-4" data-id="element-196">
              {bullets.map((bullet, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-center gap-4 rounded-lg bg-slate-50 p-4 border border-slate-100" data-id="element-197">
                  <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-accent/10 text-brand-accent" data-id="element-198">
                    <Check size={18} strokeWidth={3} data-id="element-199" />
                  </div>
                  <span className="font-medium text-slate-700" data-id="element-200">{bullet}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}